
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { EnhancedLead } from './use-dashboard-data';

export function useLead(leadId?: string) {
  const [lead, setLead] = useState<EnhancedLead>();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!leadId) {
      setIsLoading(false);
      return;
    }

    async function fetchLead() {
      try {
        const { data, error } = await supabase
          .from('nursing_home_leads')
          .select('*')
          .eq('id', leadId)
          .single();

        if (error) throw error;

        if (data) {
          const enhancedLead: EnhancedLead = {
            ...data,
            category: 'Private', // You might want to fetch this from nursing_homes table
            is_public: false,
            bed_availability: 0,
            fair_deal: false,
            price_range: null,
          };
          setLead(enhancedLead);
        }
      } catch (error) {
        console.error('Error fetching lead:', error);
      } finally {
        setIsLoading(false);
      }
    }

    fetchLead();
  }, [leadId]);

  return { lead, isLoading };
}
